/**
 * 确认或者未确认内容
 * @author FJJ
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2022/08/12      1.0     First version   BY.GSM   .\Bill\Bill.js
 * 2022/09/15      2.0    Second version   BY.FJJ : 使用统一的组件
 * **/
import React  from 'react'
import {Alert,message,Button,Popconfirm,Popover} from 'antd';
import PropTypes from "prop-types";
import Lang from "@components/Lang/Lang";
import ShipperManagementAction from "../../../ShipperManagement.action";
import {getConfirmContainerOrderUrl} from "./common";
import {isEmpty} from '@utils/utils';
import dayjs from "dayjs";

export default class ConfirmAlert extends React.Component{
    static propTypes = {
        orderInfo: PropTypes.object.isRequired,
        orderType: PropTypes.string.isRequired,
        tipsNum: PropTypes.number,
        callBack:PropTypes.func
    }
    static defaultProps = {
        orderInfo: {},
        orderType:'',
        tipsNum:0
    }
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }
    loading(flag){
        this.setState({
            loading:flag
        })
    }
    /**
     * 确认
     **/
    confirmContainerOrder(orderType='',iId,version){
        this.loading(true);
        const url= getConfirmContainerOrderUrl(orderType);
        if(isEmpty(url)){
            this.loading(false);
            message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
        }else ShipperManagementAction.autoFetchAction({
            id: iId,
            version:version
        },url).then(res=>this.handleConfirmRes(res.data)).catch(err=>this.handleConfirmRes(err))
    }
    handleConfirmRes(res,){
        this.loading(false);
        const {success,valid} = res;
        if(success&&valid){
            message.success(Lang({id: "TiJiaoChengGong",default:'提交成功！'}));
           if(this.props.callBack) this.props.callBack()
        }else if(res.message){
            message.warning(res.message);
        } else message.warning(Lang({id:'CaoZuoShiBai',default: "操作失败",}));
    }
    componentWillUnmount(){
        this.setState = (state, callback) => {
            return;
        }
    }
    render() {
        const { orderType,orderInfo,tipsNum } = this.props;
        const { loading } = this.state;
        return (<>
            {orderInfo.status=='10'&& <Popconfirm
                placement="rightTop"
                title={<div>
                    <p>{Lang({id:'TiShi',default:'提示'})}</p>
                    {tipsNum>0?<p>{Lang({id:'HaiYouKuanShangPinMiaoShuWeiWanShan',default:'还有{0}款商品未完善，是否需要继续确认？',params:[tipsNum]})}</p>:
                    <p>{Lang({id:'QingYueDuJiaChaDanJuShuJu',default:'请阅读检查单据数据，确认此单据无问题？'})}</p>}
                </div>}
                onConfirm={()=>this.confirmContainerOrder(orderType,orderInfo.id,orderInfo.version)}
                okText={Lang({id:'queren',default:'确认'})}
                cancelText={Lang({id:'QuXiao',default:'取消'})}
            >
                <div><i className='ri-save-3-line color-danger mr_4'></i> <span className={"margin-left-5"} type={'primary'} loading={loading} >{Lang({id: "QueRenDanJu",default: "确认单据"})}</span></div>
            </Popconfirm>}
            {orderInfo.status=='20'&& 
            <Popover trigger="hover" placement="top" title={<div>{orderInfo.createByName}<span className={'margin-left-5'}>{orderInfo.createTime?dayjs(orderInfo.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span></div>
            }>
                <div>
                    <i className='ri-save-3-line color-danger mr_4'></i><span className={"margin-left-5"} type={'primary'} loading={loading} >{Lang({id: "YiQueRen",default: "已确认"})}</span>
                </div>
            </Popover>
            
            
            // <Alert className={"margin-left-5"}
            // message={<div>{orderInfo.createByName}<span className={'margin-left-5'}>{orderInfo.createTime?dayjs(orderInfo.createTime).format('YYYY-MM-DD HH:mm:ss'):'-'}</span>
            //     <span className={'margin-left-5'}>{Lang({id:'YiQueRen',default:'确认'})}</span></div>}
            // type="success"
            // showIcon />
            
            }
        </>)
    }
}
